// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js!./main-style.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("7dc8347e", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/main-style.css
// module id = 57
// module chunks = 188